import styled from "styled-components";

export const Container = styled.section`
    padding: 32px;
    min-height: calc(100vh - 78px);
    display: flex;
    flex-direction: column;
    gap: 0;
`;

export const SpaceHeader = styled.h4`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    font-size: 13px;
    text-align: center;
    & span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 100px;
    }
`;